import { Box, MenuItem } from '@mui/material';
import {
  DialogContainer,
  DialogTitle,
  DialogBody,
  DialogActions,
  CustomTextField,
  CustomTextArea,
  CustomSelect,
} from '../../../../common/components';

const ConstructionTypeDialog = ({
  open,
  onClose,
  editMode,
  constructionType,
  plans = [],
  onInputChange,
  onSave,
}) => {
  return (
    <DialogContainer open={open} onClose={onClose} size="small">
      <DialogTitle>
        {editMode ? 'Editar tipo de construcción' : 'Agregar tipo de construcción'}
      </DialogTitle>

      <DialogBody>
        <Box sx={{ display: 'grid', gap: 2 }}>
          <CustomSelect
            label="Plan"
            name="uuid_plan"
            value={constructionType?.uuid_plan || ''}
            onChange={onInputChange}
          >
            <MenuItem value="">Seleccionar plan</MenuItem>
            {plans.map((plan) => (
              <MenuItem key={plan.uuid} value={plan.uuid}>
                {plan.name}
              </MenuItem>
            ))}
          </CustomSelect>

          <CustomTextField
            label="Nombre"
            name="name"
            value={constructionType?.name || ''}
            onChange={onInputChange}
          />

          <CustomTextField
            label="Superficie (m2)"
            name="surface"
            type="number"
            value={constructionType?.surface ?? ''}
            onChange={onInputChange}
            inputProps={{ min: 0, step: '0.01' }}
          />

          <CustomTextArea
            label="Descripción"
            name="description"
            value={constructionType?.description || ''}
            onChange={onInputChange}
            minRows={3}
          />

          <CustomTextField
            label="URL de imagen"
            name="image_url"
            value={constructionType?.image_url || ''}
            onChange={onInputChange}
          />
        </Box>
      </DialogBody>

      <DialogActions handleClose={onClose} handleSave={onSave} />
    </DialogContainer>
  );
};

export default ConstructionTypeDialog;
